import { gql, useQuery } from "@apollo/client";
import { Button, Input, Layout, Menu, PageHeader, Row, Table, Tag } from "antd";
import moment from "moment";
import React, { Fragment, useState } from "react";

const accountSessionsQuery = gql`
  query($pagination: ConnectionPagination, $sorting: AccountUserSorting, $searchQuery: String) {
    accountSessions(pagination: $pagination, sorting: $sorting, searchQuery: $searchQuery) {
      nodes {
        id
        createdAt
        remoteIp
        currentUser {
          code
          email
          role
          companyName
        }
        user {
          code
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        page
        size
      }
      totalCount
      totalPages
    }
  }
`;

export const List: React.FC<{}> = () => {
  const [searchQuery, setSearchQuery] = useState<string>("");

  const variables = {
    pagination: { page: 1, pageSize: 0 },
    orderBy: { direction: "ASC", field: "ID" },
    searchQuery,
  };
  const { loading, data } = useQuery(accountSessionsQuery, { variables, fetchPolicy: "cache-and-network" });

  const handleSearch = (value: string) => setSearchQuery(value);
  const handleSearchCancel = () => setSearchQuery("");
  const handleTableChange = () => {};

  const columns = [
    {
      title: "Date",
      render: (resource: any) => moment(resource.createdAt).format("DD-MM-YYYY @ HH:mm"),
    },
    {
      title: "Code",
      render: (resource: any) => resource.currentUser.code,
    },
    {
      title: "Company Name",
      render: (resource: any) => <b>{resource.currentUser.companyName}</b>,
    },
    {
      title: "Role",
      render: (resource: any) => {
        const role = resource.currentUser.role;
        let color;
        if (role === "ADMIN") color = "volcano";
        if (role === "SALESPERSON") color = "blue";
        return <Tag color={color}>{role}</Tag>;
      },
    },
    {
      title: "Impersonator",
      render: (resource: any) =>
        resource.user.code !== resource.currentUser.code ? <Tag color="blue">{resource.user.code}</Tag> : "",
    },
    {
      title: "Remote IP",
      dataIndex: "remoteIp",
    },
  ];

  return (
    <Fragment>
      <Layout.Header className="header-background">
        <Row justify="space-between">
          <Menu theme="light" mode="horizontal">
            <Input.Search
              placeholder="search"
              onSearch={handleSearch}
              key={variables.searchQuery ?? "__search__"}
              defaultValue={variables.searchQuery ?? ""}
              style={{ width: 500, margin: "16px 30px" }}
              />
            <Button disabled={searchQuery.length === 0} onClick={handleSearchCancel} style={{ margin: "16px 0" }}>
              Cancel
            </Button>
          </Menu>
        </Row>
      </Layout.Header>
      <Layout className="content">
        <PageHeader ghost={true} title="Accesses" />
        <Layout.Content className="content">
          <Table
            rowKey="id"
            loading={loading}
            columns={columns}
            dataSource={data?.accountSessions.nodes}
            pagination={{
              hideOnSinglePage: true,
              showSizeChanger: true,
              showTotal: (total, range) => `Showing ${range} of ${total}`,
              total: data?.totalCount ?? 0,
              defaultPageSize: 50,
            }}
            onChange={handleTableChange}
          />
        </Layout.Content>
      </Layout>
    </Fragment>
  );
};
